<!-- npm install vue-draggable-next -->
<template>
  <div>
    <!-- フィルター -->
    <div class="px-4">
      <p>ソート</p>
      <div class="pb-8">
        <v-row dense class="mt-2">
          <v-col
            v-for="col in columns"
            :key="col.key"
            cols="4" sm="6"
          >
            <v-btn @click="sort_by(col.key)">
              {{ col.label }}
              <span v-if="sort.key === col.key">
                {{ sort.order === 'asc' ? '▲' : '▼' }}
              </span>
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </div>
    <!-- リスト -->
    <div>
      <table class="min-w-full no_border" :style="table_stayle">
        <draggable
          tag="tbody"
          v-model="sorted_items"
          item-key="id"
          @end="onDragEnd"
          :animation="200"
          :delay="200"
        >
          <template #item="{ element }">
            <tr 
              style="text-align: center;"
              :style="is_checked(element)"
              :class="{checked_color: is_checked(element)}"
            >
              <!-- チェックボックス -->
              <td
                class="px-2"
                style="justify-items: center; width: 10%;"
                @click="check_item(element)"
              >
                <v-checkbox
                  v-model="element.checked"
                  class="round-checkbox"
                  color="primary"
                  hide-details
                />
              </td>
              <!-- 名前群 -->
              <td 
                @click="on_click(element)"
                :class="{checked_font: is_checked(element)}"
              >
                <div style="text-align: left;" class="px-4" >
                  <!-- 名前 -->
                  <span
                    v-for="data_key in order.slice(1, 2)" :key="data_key"
                    style="font-weight: bold;"
                  >
                    {{ element[data_key] ?? '' }}
                  </span>
                  <!-- 数量 -->
                  <span
                    v-for="data_key in order.slice(2, 3)" :key="data_key"
                  >
                    × {{ element[data_key] ?? '' }}
                  </span>
                  <!-- タグ群 -->
                  <div style="color: gray;">
                      <span
                        v-for="data_key in order.slice(3, 4)" :key="data_key"
                      >
                        <span v-if="element[data_key]">
                          [{{ element[data_key] ?? '' }}]
                        </span>
                      </span>&nbsp;&nbsp;
                      <span
                        v-for="data_key in order.slice(4, 5)" :key="data_key"
                      >
                        <span v-if="element[data_key]">
                          [{{ element[data_key] ?? '' }}]
                        </span>
                      </span>
                  </div>
                </div>
              </td>
            </tr>
          </template>
        </draggable>
      </table>
    </div>
  </div>
</template>

<script>
import { ref, computed } from 'vue';
import draggable from 'vuedraggable';

export default {
  name: 'ListBase',
  components: { draggable },
  props: {
    items: {
      type: Array,
      required: true
    },
    columns: {
      type: Array,
      required: true
    },
    order: {
      type: Array,
      required: true
    },
    table_stayle: {
      type: String,
      required: false
    },
    column_width_list: {
      type: Array,
      required: false
    },
  },
  setup(props, {emit}) {
    // ########
    // ソート #
    // ########
    const sort = ref({ key: '', order: 'asc' });

    const sort_by = (key) => {
      if (sort.value.key === key) {
        sort.value.order = sort.value.order === 'asc' ? 'desc' : 'asc';
      } else {
        sort.value.key = key;
        sort.value.order = 'asc';
      }
      const updated_temp_items = update_sort_number(sorted_items.value)
      emit("update", updated_temp_items, false)
    };

    const sorted_items = computed(() => {
      if (!sort.value.key || sort.value.key === 'actions') return props.items;
      return [...props.items].sort((a, b) => {
        const aValue = a[sort.value.key];
        const bValue = b[sort.value.key];
        if (aValue === bValue) return 0;
        const result = aValue > bValue ? 1 : -1;
        return sort.value.order === 'asc' ? result : -result;
      });
    });

    // ###############
    // Style
    // ###############
    const get_width = (index) => {
      return "width : " + props.column_width_list[index] + "%"
    }
    const is_checked = (element) => {
      if (element.amount < 1 || element.checked === true) {
        return true
      }
      return false
    }

    // ###############
    // ソート番号付与 #
    // ###############
    const update_sort_number = (target_items) => {
        return target_items.map((item, index) => ({
            ...item,
            row_index: index + 1
        }));  
    }

    // ##########
    // クリック #
    // ##########
    const on_click = (element) => {
        // ソート設定を解除
        sort.value.key = ""
        // emit
        emit("click_row", element)
    }

    // ##################
    // ドラッグ&ドロップ #
    // ##################
    const onDragEnd = (event) => {
        // ソート設定を解除
        sort.value.key = ""
        // DnD処理
        const old_index = event.oldIndex
        const new_index = event.newIndex
        console.log(old_index + new_index)
        // 一行にまとめると、更新されていないデータがemitで送信される
        const moved_temp_items = move_item(sorted_items.value, old_index, new_index)
        const updated_temp_items = update_sort_number(moved_temp_items)
        emit("update", updated_temp_items, true)
    };

    const move_item = (array, old_index, new_index) => {
        if (new_index >= array.length) {
            let k = new_index - array.length + 1;
            while (k--) {
            array.push(undefined);
            }
        }
        // old_indexの要素を取り出す
        const item = array.splice(old_index, 1)[0];
        // new_indexの位置に挿入する
        array.splice(new_index, 0, item);
        return array;
    }

    
    // ########
    // ソート #
    // ########
    const check_item = (element) => {
      emit("click_check", element)
    }

  return {
      // カラムのソート
      sort,
      sort_by,
      sorted_items,
      // onClick
      on_click, 
      // DnD
      onDragEnd,
      move_item,
      // style
      get_width,
      is_checked,
      // 購入
      check_item,
    };
  }
};
</script>

<style scoped>
tr:hover {
  background-color: #e3f2ff;
}
.unable-click{
  pointer-events: none;
}
.round-checkbox {
  border-radius: 50%; /* 丸くする */
}
.no_border {
  border-collapse: collapse;
  border: none;
}
.checked_color {
  background-color: lightgray
}
.checked_font {
  text-decoration: line-through;
}
</style>
